export const buildApiRequestUrl = (endpoint: string | URL, params: Record<string, string | null>) => {
  const urlToUse = typeof endpoint === 'string' ? new URL(endpoint) : endpoint
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      urlToUse.searchParams.append(key, value)
    }
  })
  return urlToUse
}
